import { render, staticRenderFns } from "./DashboardWidgetPaymentsPendingItem.vue?vue&type=template&id=2425d883&lang=pug&"
import script from "./DashboardWidgetPaymentsPendingItem.vue?vue&type=script&lang=js&"
export * from "./DashboardWidgetPaymentsPendingItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports